import { useRef } from "react";
import { MainContainer, Container2 } from "../ComponentCss";
import { WarCommonComponent } from "../CommonComponent";
import scroll_down from "../../_assets/images/scroll_down.png";
import scroll_down3 from "../../_assets/images/scroll_down3.png";
import scroll_down4 from "../../_assets/images/scroll_down4.png";
import { useState } from "react";
import { useEffect } from "react";

const MorningComponent = ({ playState, setBgIsBlack, setSupportVisible }) => {
    const componentRef = useRef([]);
    const [answer, setAnswer] = useState('');
    const [answer2, setAnswer2] = useState('');

    // 오답 클릭 시 class 추가
    useEffect(() => {
        if (answer !== '') {
            const chageAnswer = setInterval(() => {
                setAnswer('')
            }, 500);
            return () => clearInterval(chageAnswer);
        } else if (answer2 !== '') {
            const chageAnswer = setInterval(() => {
                setAnswer2('')
            }, 500);
            return () => clearInterval(chageAnswer);
        }
    }, [answer, answer2]);

    return (
        <MainContainer spyEle={ playState }>
            <Container2 className="p-11-m" ref={ el => componentRef.current[0] = el }>
                <div className="comm">
                    <p>당신이 오늘 아침 <br className="mo" />엄마에게 들은 말은?</p>
                    <div className="label-cont">
                        <label className="correct" htmlFor="morning1" onClick={() => componentRef.current[1].scrollIntoView({behavior: "smooth"})}>
                            <input type="checkbox" id="morning1" />
                            잘잤니, 아들
                        </label>
                        <label className={ answer } htmlFor="morning2" onClick={() => setAnswer('wrong') }>
                            <input type="checkbox" id="morning2" />
                            쉿, 여기숨어
                        </label>
                    </div>
                </div>
                <img src={ scroll_down } alt="scroll down 이미지" className="scroll_img pc" />
                <img src={ scroll_down3 } alt="scroll down 이미지" className="scroll_img2 mo" />
            </Container2>
            <Container2 className="p-12" ref={ el => componentRef.current[1] = el }>
                <div className="comm">
                    <p className="opacity">당신이 오늘 아침 <br className="mo" />엄마에게 들은 말은?</p>
                    <div className="label-cont">
                        <label className="correct" htmlFor="morning1_res">
                            <input type="checkbox" id="morning1_res" defaultChecked disabled />
                            잘잤니, 아들
                        </label>
                        <label htmlFor="morning2_res" className="opacity">
                            <input type="checkbox" id="morning2_res" disabled />
                            쉿, 여기숨어
                        </label>
                    </div>
                </div>
                <div className="scroll-cont">
                    <p>
                        같은 날 아침 지구 반대편의 11살 하마르는 무슨 이야기를 들었을까요?
                    </p>
                    <img src={ scroll_down4 } alt="scroll down 이미지" className="pc" />
                    <img src={ scroll_down3 } alt="scroll down 이미지" className="mo" />
                </div>
            </Container2>            
            <Container2 className="p-13 item-right" ref={ el => componentRef.current[2] = el }>
                <div className="comm">
                    <p>다음 중 11살 하마르가<br />오늘 아침 엄마에게 들은 말은?</p>
                    <div className="label-cont">
                        <label className={ answer2 } htmlFor="morning3" onClick={() => setAnswer2('wrong') }>
                            잘잤니, 아들
                            <input type="checkbox" id="morning3" />
                        </label>
                        <label className="correct" htmlFor="morning4" onClick={() => componentRef.current[3].scrollIntoView({behavior: "smooth"})}>
                            쉿, 여기숨어
                            <input type="checkbox" id="morning4" />
                        </label>
                    </div>
                </div>
                <img src={ scroll_down } alt="scroll down 이미지" className="scroll_img pc" />
                <img src={ scroll_down3 } alt="scroll down 이미지" className="scroll_img2 mo" />
                <span className="copyright copyright-r">©UNICEF/ UNI46035/ Brooks</span>
            </Container2>
            <Container2 className="p-14 item-right" ref={ el => componentRef.current[3] = el }>
                <div className="comm">
                    <p className="opacity">다음 중 11살 하마르가<br />오늘 아침 엄마에게 들은 말은?</p>
                    <div className="label-cont">
                        <label htmlFor="morning3_res" className="opacity">
                            잘잤니, 아들
                            <input type="checkbox" id="morning3_res" disabled />
                        </label>
                        <label className="correct" htmlFor="morning4_res">
                            쉿, 여기숨어
                            <input type="checkbox" id="morning4_res" defaultChecked disabled />
                        </label>
                    </div>
                </div>
                <div className="scroll-cont">
                    <p>
                        스크롤을 내려 하마르의 이야기 들어보기
                    </p>
                    <img src={ scroll_down4 } alt="scroll down 이미지" className="pc" />
                    <img src={ scroll_down3 } alt="scroll down 이미지" className="mo" />
                </div>
                <span className="copyright copyright-r">©UNICEF/ UNI46035/ Brooks</span>
            </Container2>
            <WarCommonComponent warRef={ null } setBgIsBlack={ setBgIsBlack } playState={ playState } setSupportVisible={ setSupportVisible } />
        </MainContainer>
    );
}

export default MorningComponent;
